var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.base64)?_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.base64}}):_c('j-spinner',{staticClass:"p8",attrs:{"size":"small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }